import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import Config from './../../../Config';
import { PortalStep, simType, UserStatusMsg } from './Enum';
import { MessageContent } from './Constant';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { cgTypeEnum } from '../../../utilities/enums/cgTypeEnum';
export const GetOrgUserDetails = createAsyncThunk('organizationPortal/GetOrgUserDetails', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('GetOrgUserDetails', [data.phoneNumber, data.userId]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const UpdateOrgUserStatus = createAsyncThunk('organizationPortal/UpdateOrgUserStatus', async (data, thunkAPI) => {
  try {
    const UpdateOrgUsersReq = {
      Status: data.status,
      ErrorMsg: data.errorMsg,
      SubscriberNumber: data.subscriberNumber,
      UserId: data.userId,
    };
    const result = await ProviderManager.getProviderData('UpdateOrgUserStatus', UpdateOrgUsersReq);
    return result;
  } catch (error) {
    throw error;
  }
});

export const UpdateOrgUserDetails = createAsyncThunk('organizationPortal/UpdateOrgUserDetails', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const payment = data.userDetails.payment;
    const address = data.userDetails.address;
    const user = data.userDetails;
    const model = data.userDetails.selectedPlan.model;
    var returningOldDevice = '';
    if (data.userDetails.actionType === 'upgrade' && data.orgDetails.allowReturningOldDevice) {
      returningOldDevice = data.userDetails.isReturningOldDevice ? 'true' : 'false';
    } 

    const orgUserData = {
      user: {
        userId: user.userId ?? '',
        firstName: user.firstName ?? '',
        lastName: user.lastName ?? '',
        subscriberNumber: user.subscriberNumber ?? '',
        mail: user.mail ?? '',
        userType: user.userType ?? '',
        altPhoneNumber: user.altPhoneNumber ?? '',
        orgName: data.orgDetails.orgName ?? '',
        distributionCenter: user.selectedDCenter ?? '',
        simType: simType.Sim,
        orgId: user.orgId ?? '',
        phoneModelId: model.itemId ?? '',
        phoneModelName: model.itemId ? model.name : '',
        phoneModelStorage: model.itemId ? model.storage + 'GB' : '',
        phoneModelColor: model.itemId ? model.color : '',
        planCode: user.selectedPlan.package.packageId ?? '',
        isThirdPartyApproved: user.thirdPartyApproved ?? false,
        ban: user.ban ?? '',
        paymentDetails: {
          pType: payment.PType ?? cgTypeEnum.CHECKCARD,
          bankName: payment.Bank?.bankName ?? '',
          bankAccountNo: payment.Bank?.bankAccountNo ?? '',
          bankBranch: payment.Bank?.branchCode ?? '',
          bankCode: payment.Bank?.bankCode ?? '',
          isAutomatedBank: payment.Bank?.isAutomatedBank ?? false,
          creditCardNo: payment.CreditCard?.ccToken ?? '',
          creditCardType: payment.CreditCard?.ccType ?? '',
          creditCardExpirationDate: '20' + payment.CreditCard?.cardDueYear + payment.CreditCard?.cardDueMonth + '01' ?? '',
          mail: payment.Bank?.mail ?? '',
          numOfPayments: payment.numOfPayments ?? '1',
        },
        address: {
          street: address?.street ?? '',
          city: address?.city ?? '',
          houseNum: address?.houseNum ?? '',
          entry: address?.entry ?? '',
          apartment: address?.apartment ?? '',
          zipCode: address?.zipCode ?? '',
        },
        isReturningOldDevice: returningOldDevice,
        actionType: data.userDetails.actionType,
      },
      segment: {
        accountType: data.orgDetails.segment.accountType,
        subType: data.orgDetails.segment.subType,
        midType: data.orgDetails.segment.midType,
      },
      parentBan: data.orgDetails.parentBan,
      billCycle: data.orgDetails.billCycle
    };
    const result = await ProviderManager.getProviderData('UpdateOrgUserDetails', orgUserData);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const getBanksList = createAsyncThunk('organizationPortal/getBanksList', async (data, thunkAPI) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const result = await ProviderManager.getProviderData('getBanksList', []);
    return result;
  } catch (error) {
    throw error;
  }
});
export const getBankBranchesList = createAsyncThunk('organizationPortal/getBankBranchesList', async (data, thunkAPI) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const result = await ProviderManager.getProviderData('getBankBranchesList', [data.bankCode]);
    return result;
  } catch (error) {
    throw error;
  }
});
export const CreateSplitSignatureFile = createAsyncThunk('organizationPortal/CreateSplitSignatureFile', async (data, thunkAPI) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const result = await ProviderManager.getProviderData('CreateSplitSignatureFile', data);
    return result;
  } catch (error) {
    throw error;
  }
});

export const PaymentMethodValidation = createAsyncThunk('organizationPortal/PaymentMethodValidation', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    data = { ...data, isOrgPortalReq: true };
    const result = await ProviderManager.getProviderData('PaymentMethodValidation', data);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const CheckSplitFileSignature = createAsyncThunk('organizationPortal/CheckSplitFileSignature', async (fileGuid, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('CheckSplitFileSignature', [fileGuid]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
const initialState = {
  error: false,
  epiContent: '',
  userDetails: {
    firstName: '',
    lastName: '',
    userId: '',
    phoneNumber: '',
    status: '',
    mail: '',
    userType: '',
    altPhoneNumber: '',
    address: {
      street: '',
      city: '',
      houseNum: '',
      entry: '',
      apartment: '',
      zipCode: '',
      floor: '',
    },
    payment: {
      PType: cgTypeEnum.CHECKCARD,

      CreditCard: {},
      Bank: {
        bankName: '',
        bankAccountNo: '',
        branchCode: '',
        bankCode: '',
        isAutomatedBank: false,
        mail: '',
      },
    },
    selectedDCenter: '',
    isReturningOldDevice: false,
    selectedPlan: {
      package: {
        packageId: '',
        packageName: '',
        price: '',
        termLink: '',
      },
      model: {},
    },
  },
  splitFile: {
    url: '',
    guid: '',
    isSigned: false,
  },
  products: [],
  thirdPartyCheck: false,
  orgDetails: {
    segment: {},
    orgName: '',
    parentBan: '',
    billCycle: '',
    distributionCenters: [],
    orgPlans: [],
    allowBankPayment: '',
  },
  stepsList: Object.values(PortalStep).filter((step) => step !== PortalStep.OtpVerifyPhonePage),
  steps: {
    current: PortalStep.OtpVerifyPhonePage,
    previous: '',
  },
  messageContent: '',
  showPopup: '',
};

const OrganizationPortalSlice = createSlice({
  name: 'organizationPortal',
  initialState: initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.steps = {
        previous: action.payload.previous ?? '',
        current: action.payload.current,
      };
      return state;
    },
    setEpiContent: (state, action) => {
      state.epiContent = action.payload;
      return state;
    },
    setShowPopUp: (state, action) => {
      state.showPopup = action.payload;
      return state;
    },
    setPopUpMessage: (state, action) => {
      state.showPopup = true;
      state.messageContent = action.payload;
      return state;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    setUserDetails: (state, action) => {
      state.userDetails = { ...state.userDetails, ...action.payload };
      return state;
    },
    setSplitFile: (state, action) => {
      state.splitFile.isSigned = action.payload;
      return state;
    },

    setThirdPartyCheck: (state, action) => {
      state.thirdPartyCheck = action.payload;
      return state;
    },
    setSelectedPlan: (state, action) => {
      state.userDetails.selectedPlan = { ...state.userDetails.selectedPlan, ...action.payload };
      return state;
    },
    setIsReturningOldDevice: (state, action) => {
      state.userDetails.isReturningOldDevice = action.payload;
      return state;
    },
    setProducts: (state, action) => {
      state.products = [...action.payload];
      return state;
    },
  },
  extraReducers: {
    [GetOrgUserDetails.fulfilled]: (state, action) => {
      if (action.payload.userErrorMsgEnum != null) {
        var messageContent = MessageContent.TempFailure;
        messageContent.title = UserStatusMsg[action.payload.userErrorMsgEnum];
        state.messageContent = messageContent;
        state.showPopup = true;
      } else {
        var user = action.payload.user;
        state.userDetails = { ...state.userDetails, ...user };
        if (user.actionType == 'upgrade') {
          state.userDetails.phoneNumber = user.subscriberNumber;
          const creditCardNo = user.lastDigitCC ?? '';
          if (creditCardNo) {
            state.userDetails.payment = {
              ...state.userDetails.payment,
              CreditCard: {
                ...state.userDetails.payment.CreditCard,
                credit4Digits: creditCardNo.length > 4
                  ? creditCardNo.slice(creditCardNo.length - 4)
                  : creditCardNo,
              },
            };
          }
        }
        //user enter after ban creation
        if (state.userDetails.ban != '') {
          state.userDetails.selectedDCenter = user.distributionCenter;
        }
        const orgData = action.payload.epiOrgData;
        state.orgDetails = {
          ...state.orgDetails,
          orgName: orgData.organizationName,
          distributionCenters: orgData.orgDistributionCenters,
          orgPlans: [...orgData.orgPortalPlan],
          segment: { ...orgData.segment },
          parentBan: orgData.parentBan,
          billCycle: orgData.billCycle,
          allowBankPayment: orgData.allowBankDebitPayment,
          displayThirdPartyCB: orgData.displayThirdPartyCB,
          allowReturningOldDevice: orgData.returnDeviceUpgrade,
          orderSummaryNote: orgData.orderSummaryNote,
        };
        if (user.actionType == 'upgrade') {
          const currentOrgPackage = orgData.orgPortalPlan
            .map((plan) => plan.package)
            .find((pkg) => pkg.offerID.value == user.planCode);
          if (!currentOrgPackage) {
            state.messageContent = {
              ...MessageContent.GeneralError,
              subTitle: MessageContent.NoPlanDetailsFound.subTitle,
            };
            state.showPopup = true;
            return state;
          }
        }
        if (orgData.orgPortalPlan[0].orgPortalProducts.length == 0) {
          state.stepsList = state.stepsList.filter((step) => step !== PortalStep.ProductSelection);
        }
        state.steps.current = PortalStep.PlanSelection;
      }
      return state;
    },
    [GetOrgUserDetails.rejected]: (state, action) => {
      state.messageContent = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },

    [UpdateOrgUserDetails.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        if (state.userDetails.ban == '') {
          state.messageContent = MessageContent.CreateBanSuccess;
        } else if (state.userDetails.actionType == 'upgrade') {
          state.messageContent = MessageContent.UpgradeSuccess;
        } else {
          state.messageContent = MessageContent.UpdateUserSucceeded;
        }
      }else{
         state.messageContent = MessageContent.GeneralError;
      }
      state.showPopup = true;
      return state;
    },
    [UpdateOrgUserDetails.rejected]: (state, action) => {
      state.messageContent = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },

    [CreateSplitSignatureFile.fulfilled]: (state, action) => {
      if (!action.payload.Body.errorMsg) {
        state.splitFile.url = action.payload.Body.signUrl;
        state.splitFile.guid = action.payload.Body.fileGuid;
      } else {
        //
      }
      return state;
    },
    [CreateSplitSignatureFile.rejected]: (state, action) => {
      state.messageContent = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },
    [CheckSplitFileSignature.fulfilled]: (state, action) => {
      state.splitFile.isSigned = action.payload.Body.isSigned;
      return state;
    },
  },
});

export const {
  setCurrentStep,
  setEpiContent,
  setShowPopUp,
  setPopUpMessage,
  saveToHistory,
  setUserDetails,
  setThirdPartyCheck,
  setSelectedPlan,
  setProducts,
  setSplitFile,
  setIsReturningOldDevice,
} = OrganizationPortalSlice.actions;

export default OrganizationPortalSlice.reducer;
